export const sortLogic = (draggedIndex, overIndex, ref, monitor) => {
  if (draggedIndex === overIndex) return false;
  const hoverBoundingRect = ref.current.getBoundingClientRect();
  const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
  const clientOffsetY = monitor.getClientOffset();
  const hoverClientY = clientOffsetY.y - hoverBoundingRect.top;
  if (draggedIndex < overIndex && hoverClientY < hoverMiddleY) return false;
  if (draggedIndex > overIndex && hoverClientY > hoverMiddleY) return false;
  return true;
}